import en from "../i18n/translations/en/en.json";
import de from "../i18n/translations/de/de.json";
import es from "../i18n/translations/es/es.json";
import fr from "../i18n/translations/fr/fr.json";
import ja from "../i18n/translations/ja/ja.json";
import ko from "../i18n/translations/ko/ko.json";
import cn from "../i18n/translations/cn/cn.json";
import ru from "../i18n/translations/ru/ru.json";
import it from "../i18n/translations/it/it.json";
import pt from "../i18n/translations/pt/pt.json";

let translations = {
    en, de, es, fr, ja, ko, cn, ru, it, pt
};

window.get_lib = (
    open_rdk: boolean,
    name: string, 
    type: string,
) => {
    if (open_rdk){
        // Counts like a download but opening directly in RoboDK
        window.gtag('event','download-open',{'event_category':'engagement','event_label':name});
    } else {
        window.gtag_dwl(name);
    }
    var cdn_lib_path = null;
    if (window.Paths.ROBODK_CDN){
        // "https://dh2zq2763s2kl.cloudfront.net/downloads-library"; // no trailing slash!
        cdn_lib_path = window.Paths.ROBODK_CDN + "/downloads-library";
    }
    // let cdn_lib_path = null; // disable cdn
    let lib_dir = {
        "robot": cdn_lib_path ? "library-robots" : "robotlib",
        "tool": cdn_lib_path ? "library-tools": "robotlib",
        "station": "library-stations",
        "addin": "library-addins",
        "post": "library-post",
    };
    let get_lib_func = {
        "robot": "getlib",
        "tool": "gettool",
        "station": "getlib",
        "addin": "getaddin",
        "post": "getpost",
    };
    let fname = encodeURIComponent(name);

    // Open browser link that open RoboDK (app or web)
    if(open_rdk) {
        //console.log("Opening robot in RoboDK: " + fname);

        // RoboDK Web
        if(window.Settings.on_robodk_web) {
            if (type == "station"){
                // let lang = window.location.search.split("Lang=")[1] || "";
                // pathname takes care of language!!
                // url 
                // https://web.robodk.com/web?-OpenURL=//web.robodk.com/library-stations/lib/Additive-Manufacturing-and-Machining-with-Mecademic-Meca500-R3.rdk
                // Important: Here we are in an iframe within an iframe! We need the upmost url
                // var hlocation = window.parent.parent.location;
                // Workaround to make this compile
                var open_new_tab = true;
                var empty_station = false; 
                try {
                    empty_station = eval("window.parent.ItemTree.treeItems.length") <= 1;
                } catch (error) {
                    console.log(error);
                }
                var no_new_tabs = window.location.search.includes("--NoNewTabs");
                if (empty_station){
                    open_new_tab = false;
                } else if (no_new_tabs){
                    if (confirm("You'll loose your changes to the current project. Continue?")){
                        open_new_tab = false;
                    } else {
                        // abort operation
                        return;
                    }
                }
                // Open in new browser window!!
                if (open_new_tab){
                    var open_host = "web.robodk.com";
                    var open_hostandpath = open_host + "/web";
                    try {
                        var hlocation = window.parent.location;
                        if (window.parent.parent != null && window.parent.parent.location.hostname.includes("robodk.com")){
                            // We are on robodk.com/web (2 nested iframes)
                            hlocation = window.parent.parent.location;
                        } else {
                            // Added to make it work on OnShape (1 nested iframe), we should not get here though
                        }
                        open_host = hlocation.hostname;
                        open_hostandpath = hlocation.hostname + hlocation.pathname;
                    } catch (error){
                        console.log(error);
                    }
                    var url = "//" + open_hostandpath + "?-OpenURL=//" + open_host + "/" + lib_dir[type] + "/lib/" + fname;
                    if (cdn_lib_path){
                        url = "//" + open_hostandpath + "?-OpenURL=" + cdn_lib_path + "/" + lib_dir[type] + "/" + fname;
                    }
                    
                    window.open(url, '_blank').focus();
                    return;
                }
            } //else {
            //    window.parent.postMessage({ func: get_lib_func[type], location: lib_dir[type], message: fname }, "*");
            //}
            if (cdn_lib_path){
                window.parent.postMessage({ func: "loadfile", url: cdn_lib_path + "/" + lib_dir[type] + "/" + fname}, "*");
            } else {
                window.parent.postMessage({ func: get_lib_func[type], location: lib_dir[type], message: fname }, "*");
            }

        // RoboDK App
        } else {
            var url = "robodk://OpenURL=HTTP__" + window.location.hostname + "/" + lib_dir[type] + "/" + get_lib_func[type] + "?fname=" + fname;
            if (cdn_lib_path){
                url = "robodk://OpenURL=HTTP__" + cdn_lib_path.substring(8) + "/" + lib_dir[type] + "/" + fname;
            }
            window.location.assign(url);
        }

    // Download link
    } else {
        var url = "//" + window.location.hostname + "/" + lib_dir[type] + "/" + get_lib_func[type] + "?fname=" + fname;
        if (cdn_lib_path){
            url = cdn_lib_path + "/" + lib_dir[type] + "/" + fname;
        }
        window.location.assign(url);
    }
};

window.get_search_params = () => {
    let ret: stringStringMap = {};

    if(window.location.search != "") {
        window.location.search.substring(1).split("&").map((param) => {
            //console.log("param", param);
            let splitted_params = param.split("?").map((p) => {
                let temp = p.split("=");
                if (temp[0] == "Lang")
                    ret[temp[0]] = temp[1];

                return p.split("=");
            });
        });
    }

    return ret;
};

window.get_language = (params: stringStringMap) => {
    if (params.hasOwnProperty("Lang")){
        if (window.Languages.supported_languages.includes(params["Lang"])){
            return params["Lang"];
        } else {
            console.log("Warning: Unsupported language: " + params["Lang"]);
            return "en";
        }
    }
    let pathname_split = window.location.pathname.slice(1).split("/");
    if (pathname_split.length < 2){
        return "en";
    }
    for (let i=0; i<window.Languages.supported_languages.length; i++){
        if (window.Languages.supported_languages[i] == "en"){
            continue;
        }
        if (pathname_split.includes(window.Languages.supported_languages[i])){
            return window.Languages.supported_languages[i];
        }
    }
    return "en";
}

window.fetchCurrency = async () => {
    // const ipResponse = await fetch('https://api.ipify.org?format=json');
    let currencyData = {};

    // TODO: we should remove the symbol and use a function like:
    /*
    function format_cur(value){
        fmtcur = 'EUR';
        fmtloc = 'de-DE';
        return value.toLocaleString(fmtloc, { style: 'currency', currency: fmtcur });
    }
    */
    let currencySymbols = {
        "usd": "$",
        "cad": "$",
        "eur": "€",
    }

    //if (!ipResponse.ok) {
    //    currencyData = { 
    //        "Country2": "UK", 
    //        "Currency": "eur",
    //        "IP": "127.0.0.1" 
    //    }
    //}
    //const ipData = await ipResponse.json();
    //const userIP = ipData.ip;

    //const currencyResponse = await fetch(`https://robodk.com/_myinfo?IP=${userIP}`);
    // If we don't provide the IP: RoboDK takes the requestor IP
    const currencyResponse = await fetch('https://robodk.com/_myinfo');
    if (!currencyResponse.ok) {
        currencyData = { 
            'Country2': "UK", 
            "Currency": "eur", 
            "IP": "127.0.0.1" 
        }
    }
    currencyData = currencyResponse.json();
    return currencyData;
}
window.format_currency = (cur: string, value: number) => {
    let fmtcur = cur.toUpperCase();
    let fmtloc = 'de-DE';
    if (cur == "usd"){
        fmtloc = 'en-US';
    } else if (cur == "cad"){
        fmtloc = 'en-CA';
    } else if (cur == "cny"){
        fmtloc = 'zh-CN';
    }
    return value.toLocaleString(fmtloc, { style: 'currency', currency: fmtcur });
}


window.FOLDER_TYPE_IMG_MAP = {
    "R": window.Paths.FOLDER_ROBOTS_IMG,
    "E": window.Paths.FOLDER_AXES_IMG,
    "M": window.Paths.FOLDER_MECHANISMS_IMG,
    "T": window.Paths.FOLDER_TOOLS_IMG,
    "O": window.Paths.FOLDER_OBJECTS_IMG,
};

window.FOLDER_TYPE_IMG_MAP_CDN = {
    "R": window.Paths.ROBODK_CDN + window.Paths.FOLDER_ROBOTS_IMG_CDN,
    "E": window.Paths.ROBODK_CDN + window.Paths.FOLDER_AXES_IMG_CDN,
    "M": window.Paths.ROBODK_CDN + window.Paths.FOLDER_MECHANISMS_IMG_CDN,
    "T": window.Paths.ROBODK_CDN + window.Paths.FOLDER_TOOLS_IMG_CDN,
    "O": window.Paths.ROBODK_CDN + window.Paths.FOLDER_OBJECTS_IMG_CDN,
};
